module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_munkatars1 (1) 1.763310f9.jpg";